export const TERMS_TEXT = `Orbit 轨迹 用户服务协议

更新日期：2026年3月27日
生效日期：2026年3月27日
开发者：Yanrong Chen

【前言】
在使用 Orbit 轨迹（以下简称"Orbit"或"本应用"）的各项服务之前，请您仔细阅读本协议。如您不同意本协议的内容，请立即停止使用本应用。一旦您开始使用，即视为您已阅读、理解并同意接受本协议的全部条款。

本应用面向 18 周岁及以上用户。如您未满 18 周岁，请在监护人的陪同和同意下使用。

---

【一、服务内容与使用范围】

Orbit 是一款面向熟人的私密回忆记录应用，提供以下服务：
- 发布、存储和浏览个人及好友共同的回忆（含文字、照片、视频、位置、语音评论）
- 好友系统：通过邀请码添加好友，共同查看被打标的回忆
- 友情地图：以地图形式可视化回忆足迹
- 共享账单：在好友之间记录和管理共同花销
- 回忆相册：将回忆整理为相册和海报

未来 Orbit 可能会推出更多功能，用户在使用时应遵守本协议的相关规定。

---

【二、账号注册与管理】

1. 注册时须提供真实有效的邮箱地址，并自行设定密码。您有责任保管好您的账号登录凭证，不得将账号转让、出借或共享给他人。
2. 您需对使用本账号进行的一切操作负责。
3. 如发现账号被他人未经授权使用，请立即联系我们：support@wehihi.com。
4. Orbit 有权在合理通知后对违规账号采取限制或封禁措施。

---

【三、用户内容与知识产权】

1. 您发布的回忆内容（文字、照片、视频、语音等）的知识产权归您本人所有。
2. 您授予 Orbit 在提供服务所必需的范围内使用、存储、展示上述内容的非独家许可，该许可仅用于实现应用功能，不用于商业广告或数据出售。
3. 您保证您发布的内容不侵犯任何第三方的版权、肖像权、隐私权或其他合法权益。
4. 您对通过本应用发布的所有内容承担法律责任。

---

【四、禁止内容】

任何用户不得利用 Orbit 发布、存储或传播以下内容：
1. 违反宪法确定的基本原则的内容；
2. 危害国家安全、泄露国家秘密、破坏国家统一的内容；
3. 损害国家荣誉和利益的内容；
4. 煽动民族仇恨、民族歧视，破坏民族团结的内容；
5. 宣扬邪教或封建迷信的内容；
6. 散布谣言，扰乱社会秩序，破坏社会稳定的内容；
7. 散布淫秽、色情、赌博、暴力、恐怖或教唆犯罪的内容；
8. 侮辱、诽谤他人，侵害他人合法权益的内容；
9. 侵犯他人隐私权的内容（如未经他人同意发布其照片或位置）；
10. 其他违反法律、行政法规禁止的内容。

---

【五、好友系统与内容可见性】

1. 回忆采用"标签制"可见性，仅发布者本人及被明确打标的好友可以看到该回忆，仅是好友关系不赋予查看权限。
2. 您在标记好友前，请确保已获得对方同意。
3. 删除好友关系后，历史打标记录不会自动撤销。如需彻底撤回访问权限，需手动编辑或删除相关回忆。

---

【六、数据与隐私】

1. Orbit 不出售您的个人信息，不将数据用于广告投放或跨平台追踪。
2. 数据存储于境外（美国）的云端服务器（Supabase Inc.），已依法采取跨境数据保护措施。
3. 账号注销后，所有相关数据将在 7 个工作日内被永久删除，此操作不可恢复。
4. 详细的数据处理方式请参见《Orbit 隐私保护政策》。

---

【七、免责声明】

1. Orbit 按"现状"提供服务，不对因网络故障、系统错误、第三方服务中断或不可抗力导致的任何损失承担责任。
2. 本应用不对用户发布内容的准确性、真实性或适用性负责。
3. 本应用不对因用户疏忽未查看回忆或提醒而造成的任何损失承担责任。
4. 第三方服务（如 Apple Maps、Supabase 等）受其各自服务条款约束，Orbit 不对第三方服务的可用性或内容承担责任。

---

【八、协议修改】

Orbit 可根据国家法律法规的变化及业务需要随时修改本协议。修改后的条款将在应用内通知用户，继续使用即视为接受修改后的协议。

---

【九、联系我们】

邮件：support@wehihi.com
应用内：我的 → 设置 → 帮助与客服
用户协议链接：https://wehihi.com/terms/
我们将在 15 个工作日内回复。`;

export const PRIVACY_TEXT = `Orbit 轨迹 — 隐私保护政策

生效日期：2026年3月27日
开发者：Yanrong Chen

【前言】
Orbit 轨迹致力于为用户提供回忆记录、好友互动、地图足迹、共享账单等服务。我们深知个人信息对您的重要性，并郑重承诺保护您的隐私和个人信息安全。账号注销后，您的数据将在 7 个工作日内被永久删除。

如有任何疑问，可通过"我的 → 设置 → 帮助与客服"或发送邮件至 support@wehihi.com 联系我们。

---

【一、我们收集的信息】

1.1 账号注册与登录
- 邮箱地址：用于注册、登录、找回密码
- 密码：以加密哈希方式存储，我们无法获取明文密码
- 用户名：用于应用内展示，可随时修改

1.2 个人资料
- 头像：可从相册上传，或使用系统随机生成的头像

1.3 位置信息（需授权）
- 发布回忆时标记地点（经纬度、地名、详细地址）
- 在"友情地图"上展示回忆足迹
- 使用地点搜索时，关键词会发送至 Apple Maps 进行地理编码

1.4 相册与媒体文件（需授权）
- 仅在您主动选择上传时访问相册，不扫描或自动收集

1.5 麦克风（需授权）
- 仅用于语音评论功能，录制在您主动触发时进行

1.6 相机（需授权）
- 仅用于直接拍摄照片或视频用于发布回忆

1.7 设备信息（自动收集）
- 设备型号、操作系统版本、IP 地址、网络类型
- 应用版本号、崩溃日志
- iOS 设备上收集 IDFV（厂商级设备标识符），仅用于故障排查，不用于广告或跨 App 追踪；不收集 IDFA

1.8 本地存储
- 维持登录状态、保存偏好设置（如深色模式）
- 已读/未读状态标记（如评论和点赞的未读计数）
- 这些数据仅存储在您的设备本地，不上传至服务器

---

【二、好友与社交功能】

- 邀请码：系统为您生成唯一邀请码，他人可通过邀请码查找您的用户名和头像并发送好友申请
- 好友关系：互相确认后存储在服务器，好友可查看对方用户名和头像
- 回忆可见性（标签制）：回忆只有发布者本人及被明确打标的好友才能看到，仅是好友关系不赋予查看权限
- 评论：被打标好友可发布文字或语音评论，对该回忆的发布者及所有被打标好友可见
- 虚拟好友：可为未注册用户创建临时占位账号，注册后可通过邀请码绑定真实账号
- 删除好友：删除后对方账号在您好友列表中降级为虚拟好友；已打标回忆中的标签记录不自动删除，如需彻底撤回访问权限，需手动编辑回忆移除标签

---

【三、第三方服务】

我们使用以下第三方服务：
- Supabase（Supabase Inc.）：数据存储、用户认证、文件存储
- Apple MapKit JS（Apple Inc.）：地图渲染、地点搜索、地理编码
- Aegis Web SDK（腾讯云）：前端性能监控、错误日志
- Vercel Analytics（Vercel Inc.）：网页访问统计
- QuickChart：生成回忆海报中的二维码图片（分享链接 URL 会发送至该服务）

完整隐私政策（含各第三方隐私政策链接）：https://wehihi.com/privacy/

---

【四、数据共享与存储】

- 我们不出售您的个人信息，不用于广告投放或跨平台追踪
- 数据存储在 Supabase Inc. 提供的云端服务器（主要位于美国），已依法采取跨境数据传输保护措施
- 为保障服务稳定性与公平使用，单个账户当前上传存储上限约为 500MB；达到上限后将限制新增媒体上传，删除旧内容后可恢复上传
- 自动收集的信息最长保存 24 个月后删除或匿名化

---

【五、您的权利】

- 访问与更正：在"我的 → 设置 → 账户"修改邮箱、密码、用户名和头像
- 删除内容：可随时删除回忆、评论、账单、好友关系
- 账号注销：在"我的"页面发起，7 个工作日内永久删除所有数据，不可恢复
- 撤回权限：在系统设置中关闭位置、相册、麦克风、相机权限
- 允许他人分享：在"我的 → 设置 → 隐私"控制被 @ 的好友是否可转发分享您的回忆
- 数据导出：可通过 support@wehihi.com 申请，15 个工作日内以 JSON/CSV 格式提供

---

【六、未成年人保护】

Orbit 面向 18 周岁及以上用户。我们不会故意收集未成年人的个人信息。

---

【七、联系我们】

邮件：support@wehihi.com
应用内：我的 → 设置 → 帮助与客服
隐私政策链接：https://wehihi.com/privacy/
我们将在 15 个工作日内回复。`;
